import { useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';
import routes from '@srcDS/routes';

interface UseHeaderNavigationProps {
  loggedIn?: boolean;
  isMobile: boolean;
  promoLink?: string | { target: string };
}

interface UseHeaderNavigationReturn {
  onClickWishlist: () => void;
  onClickPromo: () => void;
  toggleLoginForm: boolean;
  setToggleLoginForm: React.Dispatch<React.SetStateAction<boolean>>;
}

/**
 * Custom hook to manage header navigation and interaction
 */
export const useHeaderNavigation = ({
  loggedIn,
  isMobile,
  promoLink,
}: UseHeaderNavigationProps): UseHeaderNavigationReturn => {
  const history = useHistory();
  const [toggleLoginForm, setToggleLoginForm] = useState(false);

  // Handle wishlist click (navigate or prompt login)
  const onClickWishlist = useCallback(() => {
    if (loggedIn) {
      return history.push(routes.wishlists);
    }
    setToggleLoginForm(true);
  }, [loggedIn, history]);

  // Handle promo banner click
  const onClickPromo = useCallback(() => {
    if (!isMobile) return;

    const link = typeof promoLink === 'string' ? promoLink : promoLink?.target;

    if (!link) return;

    if (link.startsWith('http://') || link.startsWith('https://')) {
      window.location.href = link;
    } else {
      history.push(link);
    }
  }, [isMobile, promoLink, history]);

  return {
    onClickWishlist,
    onClickPromo,
    toggleLoginForm,
    setToggleLoginForm,
  };
};
